import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { deactivateCppRateCard } from '~/services/LuxLoyaltyService';

import { costPerPointQueryKeys } from './costPerPointQueryKeys';

/** Deactivates an ACTIVE rate card (started -> INACTIVE, future -> DRAFT) and invalidates the list/detail caches. */
export function useDeactivateCppRateCard() {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async (id: string) => {
      return await deactivateCppRateCard(id);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: costPerPointQueryKeys.all });
      enqueueSnackbar('Rate card deactivated successfully', { variant: 'success' });
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Error deactivating rate card: ${error.message || 'Unknown error'}`, { variant: 'error' });
    },
  });
}
